export const QUESTION_COUNTER_WIDTH = '40px';
export const QUESTION_COUNTER_WIDER_WIDTH = '50px';
